import { FC } from "react";
import { IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { StoppageEvent } from "refsix-js-models";
import { DisplayEvent } from "../../models/DisplayEvent";
import { formatStoppageDuration } from "../../utils/formatDuration";
import "../components.css";

interface RenderStoppageLogInterface {
    displayEvent: DisplayEvent;
}

export const RenderStoppageLog: FC<RenderStoppageLogInterface> = ({
    displayEvent,
}) => {
    const { t } = useTranslation();
    const stoppage = displayEvent.event as StoppageEvent;

    return (
        <div className="log-half-container" data-testid="match-log-stoppage">
            <div className="log-middle-wrapper">
                <IonText className="log-event-name-text">
                    {t("model.WatchFixture.stoppageDisplayName")}
                </IonText>
                <IonText className="log-minute-play-text">
                    {displayEvent.displayMinute}
                </IonText>
                <IonText className="log-minute-play-text">
                    {formatStoppageDuration(
                        stoppage.timestamp,
                        stoppage.endTime
                    )}
                </IonText>
            </div>
        </div>
    );
};
